import firebase from '../../firebase';
import { ValidationError } from '../../utility';

let timeout = null;
const sleep = ms => {
  return new Promise((resolve, reject) => {
    clearTimeout(timeout);
    let resolved = false;
    timeout = setTimeout(() => {
      // console.log('RESOVLE ME!!!', resolve);
      resolved = true;
      return resolve();
    }, ms);
    setTimeout(() => {
      if (!resolved) {
        // console.log('RESOVLE ME!!!', resolve);
        return reject('cancelled');
      }
    }, ms + 10);
  });
};

export default function asyncValidate(values) {
  const { username } = values;
  // console.log('START DB: ', username);
  console.log('RUNNING ASYNC VALIDATE', values);
  return sleep(30)
    .then(() => {
      console.log('CALLING FIREBASE NOW ', username);
      return firebase
        .firestore()
        .collection('users')
        .where('usernameLower', '==', username.toLowerCase())
        .get()
        .then(snapshot => {
          if (snapshot && snapshot.docs && snapshot.docs.length > 0) {
            throw new ValidationError('Username not available', 'username');
          }
          return true;
        });
    })
    .catch(error => {
      // console.error('PROMISE REULT: ', error);
      return error;
    });
}



// WEBPACK FOOTER //
// ./src/containers/Signup/asyncValidate.js